import {ThemeColorPath, ThemeIconKey} from 'platform/foundation';

import {ReactNode} from 'react';

import {Nullish} from 'shared/web';

export type ActivitySidebarAction = {
  id: string;
  label: string;
  icon: ThemeIconKey;
  indicator?: ReactNode;
  component: ReactNode;
  disabled?: boolean;
  disablePadding?: boolean;
  'data-testid'?: string;
};

export type ActivityItemDataLink = {
  label: string;
  url?: string;
  icon?: ThemeIconKey;
  onClick?: () => void;
  tooltip?: string[];
};

type ActivityItemData = {
  id: string;
  title?: string;
  userName?: string;
  userId?: string | Nullish;
  timestamp?: string;
  businessCaseId?: string;
  interestType?: string | null;
  description?: string | null;
  isEditable?: boolean;
  color: ThemeColorPath;
  icon?: ThemeIconKey;
  links?: ActivityItemDataLink[];
  onClick?: () => void;
  relatedTestDrive?: {
    vehicleTitle: string | null;
    scheduledAt: string | null;
  };
};

export type TransformedActivityItem = ActivityItemData | null;
